export class UpdateRedirectURL{
    public static readonly type = '[RootState] Update redirectURL';

    constructor(public redirectURL: string) {}
}
